import baseRequest from './baseRequest';

export const fetchAllSponsors = () => {
    const url = '/new-ops/sponsors';
    const mehod = 'GET';
    return baseRequest(url, mehod, null, null);
};

export const fetchAppointmentPreference = () => {
    const url = '/new-ops/appointment-preference-options';
    const mehod = 'GET';
    return baseRequest(url, mehod, null, null);
};

export const fetchCallbackList = () => {
    const url = '/new-ops/offline-consult/active-callbacks-requests';
    const method = 'GET';
    return baseRequest(url, method, null, null);
};

export const fetchCallbackLogs = () => {
    const url = '/new-ops/offline-consult/callback-requests-call-logs';
    const method = 'GET';
    return baseRequest(url, method, null, null);
};
